import { createAction, createListenerMiddleware } from '@reduxjs/toolkit'
import { originCleared } from '../../App/app';
import { feedback } from '../../components/Feedback/feedback';
import {  customSessionUpdated } from '../../pages/CustomSSO/custom-sso';
import { macs365Uri } from '../../uris';
import {  RootState } from '../store';
import isPrivateIpv4 from '../../helpers/private-ip';
import {push} from "@lagunovsky/redux-react-router";

export const redirect = createAction( 'redirect/redirect' );
export const redirectPKCE = createAction( 'redirect/pkce' );
export const redirectLogoutUri = createAction( 'redirect/logoutUri' );

const listenerMiddlewareAuthorizedRedirection = createListenerMiddleware();

listenerMiddlewareAuthorizedRedirection.startListening( {
  actionCreator: redirect,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    console.log("redirect block");

    window.location.replace( state.app.searchParameters.redirect_uri );

  }
})

export const redirectBack = createAction( 'redirect/back' );

listenerMiddlewareAuthorizedRedirection.startListening( {
  actionCreator: redirectBack,
  effect: async( action, listenerApi ) => {
    const store = listenerApi.getState() as RootState;
    console.log("redirect back block");

    const redirectUri = store.app.searchParameters.redirect_uri;
    const referrer = document.referrer;

    // Redirect to the dashboard if no redirect URL
    // or if redirect URL does not includes referrer
    if ( !( redirectUri && referrer ) || ( redirectUri && !redirectUri.includes(referrer))) {
      console.log( 'redirect to dashboard');
      listenerApi.dispatch(push("/dashboard"));
      return;
    }

    try {

      const url = redirectUri ? new URL(redirectUri) : new URL(referrer);
      const lang = store.app.searchParameters.lang;

      // Special case for macs365
      if( url.origin.includes( macs365Uri ) ) {
        location.href = redirectUri ? `${ url }` : `${ url.origin }/${ lang }/login`;
      // Other clients
      } else {

        const searchParams = new URLSearchParams(url.search);

        searchParams.set('lang', store.app.searchParameters.lang);
        url.search = searchParams.toString();
        location.href = url.toString();
      }

    } catch(error) {

      listenerApi.dispatch(push("/dashboard"));

    }
  }
})

listenerMiddlewareAuthorizedRedirection.startListening( {
  actionCreator: redirectPKCE,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    const {
       idToken:id_token,
      accessToken:access_token,
      refreshToken:refresh_token,
    } = state.app.session;

    const { authorization_code } = state.app.searchParameters;

    const { language } = state.app;


    const body = {
      authorization_code,
      id_token,
      access_token,
      refresh_token,
    };

    return fetch( '/storage', {
      // credentials: true,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( body ),
    } ).then( ( response ) => {
      if ( response.ok ) {
        return response.json();
      } else {
        return Promise.reject( response.body );
      }
    })
    .then( () => {

      console.log("PKCE middleware");

      const state = listenerApi.getState() as RootState;
      const urlSearchParams = new URLSearchParams();

      urlSearchParams.set( 'code', state.app.searchParameters.authorization_code );
      urlSearchParams.set( 'state', state.app.searchParameters.state );

      window.location.replace( `${ state.app.searchParameters.redirect_uri }?${ urlSearchParams }`  );
    } )
    .catch( error => {
      // listenerApi.dispatch( feedback( { message: 'Could not redirect with PKCE.' }))

      // Authorization code possibly expired, restart the PKCE flow
      // Redirect to dashboard
      listenerApi.dispatch(push("/dashboard"));
    })
  }
} )

// Custom SSO

listenerMiddlewareAuthorizedRedirection.startListening( {

  actionCreator: customSessionUpdated,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    window.location.replace( state.app.searchParameters.redirect_uri );
  }
})

listenerMiddlewareAuthorizedRedirection.startListening( {
  actionCreator: originCleared,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;

    let macsx = 'macsx';

    const macsxhost = decodeURIComponent( state.app.searchParameters.macsxhost || '' );
    const [ ip ] = macsxhost.split( ':' );

    if ( isPrivateIpv4( ip ) || macsxhost.startsWith( 'macsx' ) ) {
      macsx = macsxhost;
    }

    const searchParams = new URLSearchParams();
    searchParams.set( 'license', 'false' );

    window.location.replace( `http://${macsx}/?${ searchParams }` );
  }
} )

export default listenerMiddlewareAuthorizedRedirection;
